var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import owner from "../data/owner";
import { getRandomArrayItem, getRandomTheme } from "./";

var owners = [{
    name: "val",
    title: "Valdresmusea"
}, {
    name: "byg",
    title: "Bygdøy Kongsgård"
}, {
    name: "nmm",
    title: "Norsk Maritimt Museum"
}, {
    name: "kyst",
    title: "Kystmyseet"
}, {
    name: "nkim",
    title: "Nordenfjeldske Kunstindustrimuseum"
}, {
    name: "kvi",
    title: "Kvinnemuseet"
}, {
    name: "fet",
    title: "Fetsund Lenser"
}];

var ownerImages = ["https://dms-cf-09.dimu.org/image/032yiVGVkzHu", "https://dms-cf-09.dimu.org/image/032yiziWuETr"];

export function getRandomOwner() {
    var _getRandomArrayItem = getRandomArrayItem(owners),
        name = _getRandomArrayItem.name,
        title = _getRandomArrayItem.title;

    var imageUrl = getRandomArrayItem(ownerImages);

    return _extends({}, owner, {
        name: name,
        title: title,
        imageUrl: imageUrl,
        theme: getRandomTheme()
    });
}